<form
  [formGroup]="fromToForm"
  class="bridge-range-selector rx-app-flex-container-row rx-app-flex-container-row--justify-center rx-app-flex-container-row--align-baseline"
>
  <div class="selector-container" id="rx-bridge-range-from-selector">
    <rx-select
      id="from-list-selector"
      [panelClass]="'bridge-range-selector-panel'"
      [formControl]="fromControl"
      [options]="fromOptions"
      [compareWith]="compareOptions"
      [getOptionId]="getFromOptionId"
      [getOptionName]="getOptionNameFn"
      [isReadOnly]="isReadOnly"
    ></rx-select>
  </div>

  <div
    class="mr-5 ml-5 rx-app-flex-container-column rx-app-flex-container-column--justify-space-around rx-app-flex-container-column--align-center"
  >
    <div class="to-separator" [class.read-only-separator]="isReadOnly">{{ 'ToothEditor.To' | translate }}</div>
  </div>

  <div class="selector-container" id="rx-bridge-range-to-selector">
    <rx-select
      id="to-list-selector"
      [panelClass]="'bridge-range-selector-panel'"
      [formControl]="toControl"
      [options]="toOptions"
      [compareWith]="compareOptions"
      [getOptionId]="getToOptionId"
      [getOptionName]="getOptionNameFn"
      [isReadOnly]="isReadOnly"
    ></rx-select>
  </div>
</form>
